import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import omit from 'lodash.omit';
import qs from 'query-string';

import ThankYou from './ThankYou';
import withModal from '../modal/withModal';
import { PURCHASE_TYPE } from './constants';
import { EVENT_ADDON_ITEM_TYPE } from '../../../constants/event-items';
import { PRO_REGISTRATION_PERSONAS } from '../../../views/auth/RegisterView/helpers';
import { BASENAME } from '../../../constants/basenames';
import useGtagManualTracking from '../../../services/gtag/useGtagManualTracking';
import { getPurchaseMetadataParams } from './helpers';

export const THANK_YOU_MODAL = 'modal/THANK_YOU';

const propTypes = {
  actionProps: PropTypes.shape({
    purchaseType: PropTypes.oneOf(Object.keys(PURCHASE_TYPE)),
    purchaseMetadata: PropTypes.shape({
      eventAddonDetails: PropTypes.shape({
        eventAddonItemTypes: PropTypes.arrayOf(
          Object.keys(EVENT_ADDON_ITEM_TYPE),
        ),
        freeEventConfigured: PropTypes.bool,
      }),
      subscriptionDetails: PropTypes.shape({
        searchSubscriptionItem: PropTypes.shape({
          id: PropTypes.string,
        }),
        photoManagerSubscriptionItem: PropTypes.shape({
          id: PropTypes.string,
        }),
        freeTrialAvailable: PropTypes.bool,
      }),
      verticalDetails: PropTypes.shape({
        persona: PropTypes.oneOf(PRO_REGISTRATION_PERSONAS),
        basename: PropTypes.oneOf(Object.values(BASENAME)),
      }),
    }),
  }),
};
const ThankYouModal = ({ actionProps, ...props }) => {
  const { purchaseType, purchaseMetadata } = actionProps ?? {};

  const { onTrackPageView } = useGtagManualTracking();
  useEffect(() => {
    if (purchaseType && purchaseMetadata) {
      const queryParams = getPurchaseMetadataParams(
        purchaseType,
        purchaseMetadata,
      );

      onTrackPageView({
        page_title: 'Thank You – Waldo Photos',
        page_path: `/thank-you?${qs.stringify(queryParams)}`,
      });
    }
  }, [purchaseType, purchaseMetadata]);

  return (
    <ThankYou
      purchaseType={purchaseType}
      purchaseMetadata={purchaseMetadata}
      {...omit(props, 'onRequestClose')}
    />
  );
};

ThankYouModal.propTypes = propTypes;

export default withModal(ThankYouModal, {
  name: THANK_YOU_MODAL,
  size: 'sm',
  type: 'full',
  className: 'thank-you-modal',
  overlayClassName: 'thank-you-modal-overlay',
});
